//Usage: This file will contain English strings
export default {
    // Generic errors
    Error: "Oops!",
    ERROR_GENERIC: "We're sorry, there was an error. Please try again later.",
    ERROR_GENERIC_TOAST: "We're sorry, something went wrong.",
    NetworkNotReachable:
        "It appears you are offline. Please check your Internet connection and try again.",
    NetworkUnavailable: "Network Unavailable",
    ERROR_DEVICE_REGISTRATION_FAILED_FOR_PUSH_NOTIFICATION:
        "There was an error while getting push notification token.",
    ERROR_REQUEST_TIMEOUT: "Timeout. There is no response from the Server.",
    ERROR_MANDATORY_FIELDS_CANT_BE_EMPTY: "Please fill in all required fields.",
    //Local Database
    ERROR_DB_HANDLER_FAILURE: "Database operation failed",

    //API: HTTP Response  errorMessages
    ERROR_BAD_REQUEST:
        "We're sorry, something went wrong. Please check your responses and try again. If this persists, please refresh your browser. Reason: Bad Request, Validation Failed.", //400
    ERROR_ACCESS_DENIED_AS_UNAUTHORIZED:
        "We're sorry, something seems to be wrong. Please check your account and try again. Reason: Unauthorized link", //401
    ERROR_RESOURCE_NOT_FOUND:
        "We're sorry, something went wrong. Please try again later. Reason: Resource was not found", //404
    INTERNAL_SERVER_ERROR:
        "We're sorry, something went wrong. Please try after some time. If this persists, please refresh your browser. Reason: Internal server error.", //500

    //API: API response/error messages
    ERROR_APPLICATION_ERROR:
        "We're sorry, something went wrong. Please try after some time. If this persists, please refresh your browser. Reason: Application error", //1001
    ERROR_USER_ALREADY_EXISTS:
        "There is an existing account with this number. Please go back and log in instead. ", //1002
    ERROR_USER_ALREADY_REGISTERED:
        "There is an existing account with this number. Please go back and log in instead. ", //1004
    ERROR_USER_NOT_FOUND:
        "We're sorry, something seems to be wrong here. Please check your last action, and try again. Contact us if this problem persists. Error: user not found. Reason: unable to locate user details", //1006
    ERROR_JWT_TOKEN_EXPIRED:
        "We're sorry, something seems to be wrong.Contact us if this problem persists. Reason: JWT Token expired.", //1007
    ERROR_INVALID_JWT_TOKEN:
        "We're sorry, something seems to be wrong.Contact us if this problem persists. Reason: Invalid token", //1008
    ERROR_FIELD_NOT_PRESENT_OR_INVALID:
        "We're sorry, something seems to be wrong.Contact us if this problem persists. Reason: Request field is not present or is invalid", //1013
    ERROR_INVALID_DEVICE_TYPE:
        "We're sorry, something seems to be wrong.Please check our approved device list and ensure your device meets minimum requirements. Error: Invalid device type.", //1014
    ERROR_INVALID_USER_AGENT:
        "We're sorry, something seems to be wrong.Contact us if this problem persists. Reason: Invalid user agent", //1015
    ERROR_EMAIL_ALREADY_EXISTS:
        "There is an existing account with this e-mail. Please check and use another or contact us to look into this.", //1016
    WEB_CONSOLE_LOGIN_NOT_ALLOWED:
        "We noticed you are logged in from your mobile and syncing data. Web console is only available for users who are not using data feature to view their loved ones. Please use the mobile app instead for the complete experience.", //1017
    ERROR_INVALID_FIRST_NAME:
        "Please check your first name and resubmit. If this problem persists or contact us.", //2001
    ERROR_INVALID_LAST_NAME:
        "Please check your last name and resubmit. If this problem persists or contact us.", //2002
    ERROR_INVALID_MOBILE_NUMBER:
        "Please check your mobile number and resubmit.", //2005
        EMAIL_VERIFIED_ALREADY:"Email for this user is already verified",
    ERROR_INVALID_TIMEZONE:
        "We're sorry, something seems to be wrong with your timezone settings. Please try again. Contact us if this problem persists.", //2013
    ERROR_INVALID_AUTH_GRANT: "Your session has been expired. Please login.", //2014
    ERROR_INVALID_ARGUMENT:
        "We're sorry, something went wrong.Reason: invalid argument.", //2015
    ERROR_ACCESS_DENIED:
        "We're sorry, something went wrong.Reason: Access Denied error.", //2016
    ERROR_INVALID_CLIENT:
        "We're sorry, something went wrong.Reason: Invalid client.", //2017
    ERROR_INVALID_REQUEST:
        "We're sorry, something went wrong.Reason: invalid request.", //2018
    ERROR_INSUFFICIENT_SCOPE:
        "We're sorry, something went wrong.Reason: Insufficient scope.", //2019
    ERROR_INVALID_SCOPE:
        "We're sorry, something went wrong.Reason: invalid scope.", //2020
    ERROR_UNAUTHORIZED_CLIENT:
        "We're sorry, something went wrong.Reason: unauthorized client.", //2021
    ERROR_UNAUTHORIZED_REQUEST:
        "We're sorry, something went wrong.Reason: unauthorized request.", //2022
    ERROR_UNSUPPORTED_GRANT_TYPE:
        "We're sorry, something went wrong.Reason: unsupported grant type.", //2023
    ERROR_UNSUPPORTED_RESPONSE_TYPE:
        "We're sorry, something went wrong.Reason: unsupported response type.", //2024
    ERROR_SERVER_ERROR:
        "We're sorry, something went wrong.Reason: server error.", //2025
    ERROR_INVALID_CALLING_CODE: "Calling code is not valid.", //2027
    ERROR_INVALID_REFRESH_TOKEN:
        "Your session has ended. For security reasons, please re-login. Thanks", //2029
    ERROR_INVALID_CLIENT_ID:
        "We're sorry, something went wrong.Reason: invalid client id.", //2030
    ERROR_INVALID_CLIENT_SECRET_KEY:
        "We're sorry, something went wrong.Reason: invalid client secret key.", //2031
    ERROR_INVALID_DEVICE_TOKEN:
        "We're sorry, something went wrong.Reason: invalid device token.", //2032
    ERROR_INVALID_USER_ID:
        "We're sorry, something went wrong. Please re-do your last steps and try again. Reason: invalid user id.", //2033
    ERROR_INVALID_USER_PROFILE:
        "We're sorry, something went wrong. Try again, if this problem persists or contact us. Reason: User profile could not be updated; invalid user profile.", //2034
    ERROR_OPERATION_NOT_ALLOWED:
        "We're sorry. We don't support inviting the same account type via the app. Please contact us in the app and we will do this for you. Thank you.", //2035
    ERROR_INVALID_INVITE_ID:
        "We're sorry, something went wrong. The invite you received has been invalidated. You can still sign up and request to connect with the other user.", //2037
    ERROR_INVALID_INVITATION:
        "We're sorry, something went wrong. The invite you received has been invalidated. You can still sign up and request to connect with the other user.", //2038
    ERROR_INVITATION_DOESNOT_BELONG_TO_USER:
        "We're sorry, something went wrong. The invite you received doesn't seem to be working at the moment. You can still sign up and request to connect with the other user.", //2039
    ERROR_INVALID_PARAMETER_ID:
        "We're sorry,  something seems to be wrong. Contact us if this problem persists. Reason: JWT Token expired.", //2042
    ERROR_INVALID_PARAMETER_NAME:
        "We're sorry,  something seems to be wrong. Contact us if this problem persists. Reason: invalid parameter name", //2044
    ERROR_INVALID_RECORDED_TIMESTAMP:
        "We're sorry,  something seems to be wrong. Contact us if this problem persists. Reason: invalid recorded timestamp.", //2049
    ERROR_INVALID_GRANT_TYPE:
        "Your session has been expired. Please re-login and try again. Contact us if this problem persists. Reason: invalid grant type", //2056
    ERROR_INVALID_VALUE: "", //2057
    ERROR_SUMMARY_DATA_NOT_FOUND:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Summary not found.", //2058
    ERROR_INVALID_FOR_DATE:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Date seems invalid.", //2059
    ERROR_INVALID_REQUESTED_USER_ID:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data User ID seems invalid.", //2062
    ERROR_MAPPING_NOT_FOUND:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data User Mapping not found", //2063
    ERROR_INVALID_MAX_VALUE:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Max value seems invalid.", //2064
    ERROR_INVALID_MIN_VALUE:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Min value seems invalid.", //2065
    ERROR_INVALID_AVG_VALUE:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Average value seems invalid.", //2066
    ERROR_INVALID_START_TIME:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Start time seems invalid.", //2067
    ERROR_INVALID_END_TIME:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data End time seems invalid.", //2068
    ERROR_INVALID_INTERVAL:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Interval seems invalid.", //2069
    ERROR_INVALID_USER_TYPE:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data User type seems invalid.", //2070
    ERROR_INVALID_PARAMETERS:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Parameters seems invalid.", //2071
    ERROR_INVALID_TRANSACTION_ID:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Data Transaction ID seems invalid.", //2072
    ERROR_MONITORING_USERS_NOT_FOUND:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: No monitoring user found.", //2073
    ERROR_INVALID_RELATIONSHIP:
        "We're sorry, something went wrong. Try again if this problem persists or contact us. Reason: Connection seems invalid.", //2074
    ERROR_EMAIL_SENT_FAILURE_TO_PRECONFIGURED_SUPPORT_EMAIL_ID:
        "We're sorry, something went wrong. Please try again, or e-mail us at support@allwellapp.com.", //2078
    ERROR_INVALID_EMAIL_SUBJECT:
        "We're sorry, something went wrong. Please try again, or e-mail us at support@allwellapp.com.", //2079
    ERROR_INVALID_EMAIL_MESSAGE:
        "We're sorry, something went wrong. Please try again, or e-mail us at support@allwellapp.com.", //2080
    ERROR_INVALID_EMAIL_TOPIC:
        "We're sorry, something went wrong. Please try again, or e-mail us at support@allwellapp.com.", //2084
    ERROR_INVALID_BIRTH_YEAR:
        "We're sorry, something went wrong. Please try again, or e-mail us at support@allwellapp.com.", //2092
    ERROR_UNSUPPORTED_APP_VERSION:
        "There's a new All Well version available. Please upgrade your app from the App Store to continue using and benefitting with All Well.", //3000
    UPGRADE_AVAILABLE_TITLE: "Great News! Upgrade available ",
    ERROR_INCOMING_TRANSACTION_ALREADY_ACTIVE:
        "We're sorry, something went wrong. There seems to be an existing subscription for one of the users selected. Please contact us if you need assistance here.", //2093
    ERROR_INCOMING_TRANSACTION_ALREADY_COMPLETED:
        "We're sorry, something went wrong. There seems to be an existing payment transaction for one of the users selected. Please contact us if you need assistance.", //2094
    ERROR_INCOMING_PAYMENT_REQUEST_FAILED:
        "We're sorry, something went wrong. There seems to be an incorrect user selected for payment. Please contact us if you need assistance here.", //2095
    ERROR_IN_APP_PRODUCT_ID_DOESNNOT_EXISTS:
        "We're sorry, something went wrong. Please try again. ", //2096
    ERROR_INVALID_PAYMENT_METHOD_USER:
        "We're sorry, something went wrong. Please check your payment details and try again. Contact us if this problem persists. Error #2097", //2097
    ERROR_INVALID_CARD_NUMBER:
        "We're sorry, something went wrong. Please check your payment details and try again. Contact us if this problem persists. Error #2110", //2110
    ERROR_PAYMENT_METHOD_DOESNOT_MATCH_DEFAULT_METHOD:
        "We're sorry, something went wrong. Please check your payment details and try again. Contact us if this problem persists. ", //2098
    ERROR_UNSUBSCRIBE_REQUEST_IS_INVALID:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2099", //2099
    ERROR_INVALID_SUBSCRIPTION_ID_FOR_UNSUBSCRIPTION:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2100", //2100
    ERROR_UNSUBSCRIPTION_WAS_UNSUCCESSFUL:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2102", //2102
    ERROR_INVALID_PLAN_ID_FOR_STRIPE_REQUEST:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2105", //2105
    ERROR_FAILED_TO_CREATE_SUBSCRIPTION:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2106", //2106
    ERROR_INVALID_CONNECTIONS_FOR_SUBSCRIPTION:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2107", //2107
    ERROR_INVITATION_FROM_SUBSCRIPTION_ALREADY_PRESENT:
        "We're sorry, something went wrong. There seems to be an existing subscription for one of the invited users. Please contact us if you need assistance here.", //2120
    ERROR_INVALID_OTP:
        "We're sorry, something went wrong. Please check and re-enter your one time password (OTP) and try again. Resubmit your phone number to receive a new one.", //2116
    ERROR_MOBILE_NUMBER_ALREADY_CONNECTED_TO_SENIOR:
        "The mobile number you're trying to invite is already be available in the list of connected caregivers of the chosen Senior. Please select the user from that list while upgrading.", //2118
    ERROR_USER_ALREADY_REGISTERED_AS_SENIOR:
        "The action can not be completed, because the person you are trying to invite is already registered as a Loved One in the system. Only Caregivers can be invited through the subscription flow currently.", //2117
    INVALID_REPORT_RECIPIENT_ID:
        "The recipient was not found, action cannot be completed",    
    ERROR_COUPON_NOT_FOUND:
        "We're sorry, something seems to be wrong here. Please check your coupon and try again. Contact us if this problem persists. Error #3012", //3012
    ERROR_CANNOT_APPLY_COUPON:
        "We're sorry, something seems to be wrong here. This coupon seems to have already been redeemed. Please check your coupon and try again. Contact us if this problem persists. Error #3016", //3016
    ERROR_COUPON_LIMIT_EXCEEDED:
        "We're sorry, something seems to be wrong here. Please check your selected connections and try again. Contact us if this problem persists. Error #3014", //3014
    FAILED_TO_CREATE_REPORT:
        "We're sorry, something went wrong. Please check your last action and try again. Contact us if this problem persists. Error #2134", //2134
    NOTIFICATION_OPTION_NOT_SUPPORTED:
        "This option is only available on an upgrade plan. Please press PLANS and review upgrade options to enable this feature. Error #2140", //2140
    ALERTS_LIMIT_REACHED:
        "You've reached the alert count for this connection plan. Please press PLANS and upgrade to create additional alerts. Error #2142", //2142
    ERROR_CONN_NOT_FOUND: "The connection was not found",
    ERROR_PAID_CONN_CANNOT_REM: "This user connection can only be modified from their associated organization pro account. Please contact us if you have any questions.",
    INVITATION_ALREADY_ACCEPTED:
        "Invitation is already accepted and can not be sent again.", //3004
    INVALID_GOOGLE_TOKEN:
        "We're sorry, something went wrong. Try again. Contact us if this problem persists. Error #2160", //2160
    INVALID_APP_VERSION: "Invalid app version", //2161
    MOBILE_ALREADY_EXISTS:
        "Looks like there is an existing account with this mobile number. You can either sign out and sign in with mobile number, or contact us to merge your account.", //2162
    MOBILE_OTP_EXPIRED:
        "It seems like your one time password (OTP) has expired. Please resubmit your mobile number and try again.", //2163
    MOBILE_REQUIRED:
        "To ensure user safety, this feature requires a verified mobile number. Please tap on settings on the bottom menu and verify your mobile number.", //2164
    MOBILE_REQUIRED_TITLE: "Mobile number required", //2164

    ERROR_INVALID_WEB_TOKEN:"We're sorry, something seems to be wrong. Please restart the application and try again. Contact us if this problem persists. Error #3057",
    ERROR_WEB_TOKEN_EXPIRED:"We're sorry, something seems to be wrong. Please restart the application and try again. Contact us if this problem persists. Error #3058",
    ERROR_WEB_TOKEN_NOT_FOUND:"We're sorry, something seems to be wrong. Please restart the application and try again. Contact us if this problem persists. Error #3059",
    ERROR_FAILED_TO_VERIFY_TOKEN:"We're sorry, something seems to be wrong. Please restart the application and try again. Contact us if this problem persists. Error #3062",
    ERROR_INVITATION_WITH_GIVEN_ID_NOT_FOUND:"We're sorry, something seems to be wrong. Please restart the application and try again. Contact us if this problem persists. Error #3055",

    //UI
    OK: "OK",
    Success: "Success",
    "Success!": "Success!",
    Optional: "(optl.)",

    //Welcome screen
    SignUpForFree: "JOIN ALL WELL",
    GoogleSignInBtn: "JOIN WITH GOOGLE",
    GettingStarted: "GET STARTED",
    Login: "Login",
    OpenWebApp:"OPEN WEB APP",
    AddPhoneNumber: "Add your Phone Number",
    "AddPhoneNumber Message":
        "Adding your phone number ensure you can receive and send invitations and can use all the features",
    AddPhoneBtnText: "VERIFY & ADD",
    Track: "Track",
    Share: "Share",
    Monitor: "Monitor",
    LoginInstead: "Login Instead",
    AppSlogan: "Your loved ones are All Well",
    WelcomeFirstPage: "Track your health & well-being in real-time",
    WelcomeSecondPage: "Allow family & caregivers to view your details",
    WelcomeThirdPage: "View real-time charts, get reports & alerts",
    WelcomeTo: "Welcome to",
    Welcome: "Welcome",
    SeniorText:
        "Give your family more visibility into your health and well-being.",
    LovedoneText: "Check up on your loved one's health and well-being.",
    OR: "OR",
    or:"or",
    HaveExistingAccount: "Have an existing account?",
    Account:"Account",
    SeniorBtnText: "GIVE PERMISSIONS",
    Step1TextSenior: "Give phone permissions",
    Step1TextLovedone: "Connect with your Loved one",
    Step2TextSenior: "Connect with your Caregivers",
    Step2TextLovedone: "View data & setup alerts",
    Step3TextSenior: "Update how you're feeling",
    Step3TextLovedone: "Consider upgrade options",

    //Login
    AllWell: "All Well",
    dontHaveAnAccount: "Don't have an account?",
    forgotPassword: "Forgot Password?",
    MarketingStatementOne:
        "One concise marketing statement here that is crystal clear",
    LoginMessage:
        "We will send you a one-time text message to verify your identity. Carrier rates might apply.",
    ViewAll: "View All",
    SentTo: "Sent to",
    CountryCodeErrorMessage: "Country code not available for this country.",
    ShowDemo: "Show Demo",
    DemoData:"Demo Data",

    //Sign Up
    WeUserNumberForIdentityMessage:
        "We will send you a one-time text message to verify your identity. Carrier rates might apply.",
    FirstName: "First Name",
    LastName: "Last Name",
    Email: "Email*",
    Code: "Code",
    MobileNumber: "Mobile Number",
    BirthDate: "Birth date",
    Gender: "Gender",
    ConfirmPassword: "Confirm Password*",
    Password: "Password*",
    TermsAndConditions: "I agree to the Terms & Conditions",
    PasswordValidationText:
        "Your password must have one uppercase, one number (0-9) , lower case and max length 6-15 characters, Ex: Seniorcase1",
    createAccount: "Create Account",
    SignUpCaps: "SIGN UP",
    SignUpSmall: "Sign Up",
    SignUpLogIn:"Sign up or Log in",
    SignInCaps: "SIGN IN",
    SignInSmall: "Sign In",
    SignUpForFreeTitle: "Join All Well",
    LovedOnes: "Lovedones",
    "Loved Ones": "Loved one / Senior",
    CaregiverFamily: "Caregiver / Family",
    IAmA: "I am a",
    UserSelectionDefaultMessage: "Please select one of the options above.",
    PerfectFor: "Perfect for: ",
    LovedOnesMessage:
        "I want to share my health updates with family and caregivers.",
    LovedOnesUserTypes: "Seniors, Kids & Patients",
    CareGiverMessage:
        "I want to check up on the health and wellness of my loved ones.",
    CareGiverUserTypes: "Family Members & Caregivers",
    TermAndCondition: "By tapping join All Well, you agree to our",
    TERMSOFUSE: "TERMS OF USE",
    FirstNameError: "Enter First Name",
    LastNameError: "Valid Last Name",
    MobileError: "Enter Mobile Number",
    EmailError: "Enter Email Id",
    LocationError: "Enter Location",
    GenderError: "Select Gender",
    BirthYearError: "Select Birth Year",
    PlayServicesUnavailableError:
        "Google Play Services not available on your phone.",
    HiThereTitle: "Hi There!",
    AccountAlreadyExistMessage:
        "Looks like you already have an existing account. Login instead.",
    signUpWithEmail: "SIGN UP WITH EMAIL",
    signUpWithEmailPopupMessage:
        "All Well is committed to user safety. At the moment, we only allow sign ups using mobile number. Please sign up with mobile number or check back in September 2020 when we re-allow e-mail sign ups.",

    // AccountSelection
    SelectAccountType: "Select Account Type",
    AccountSelectionMessage:
        "Thank you for signing up. What would you like to start with?",
    IWantToMonitorMsg:
        "I want to monitor the health and well-being of my loved one",
    IWantMyFamilyMsg:
        "I want to get activity reports and alerts of my elderly parents",
    IWantToTrackMsg: "I want to track and monitor my health and well-being",
    IAmNotSureMsg: "I'm not sure yet",

    //AccountActivation
    hi: "Hi",
    welcomeToApplication: "Welcome to SeniorCare Application",
    accountCreationLinkSentOn: "An account creation email has been sent to",
    clickHereToActivate: " Click on the link sent to activate account",
    didNotReceiveMail: "Didn't receive the email?",
    resendEmail: "Resend Email",
    needHelp: "Need help?",

    // OTP Dialog
    Verification: "Verification",
    verifyPhoneNumberMessage:
        "We sent you a one-time password (OTP) on your phone. Enter it below.",
    codeNotReceived: "Didn't receive it? Please wait for two minutes and ",
    codeNotReceived1:"I didn’t receive a code!",
    TryAgain: "try again.",
    resend: "RESEND",
    verify: "VERIFY",
    VerifyingOTPMsg:
        "Please wait while we verify your account. This may take up to 30 seconds.",
    verifyMobileNumber: "Verify mobile number",
    verifyMobileNumberOnAccount: "Verify your mobile number on your account.",
    verifyEmailAddress: "Verify email address",
    Verify1:"Verify",
    verifyEmailAddressOnAccount:"Verify your email address on your account.",
    addEmailAddress: "Add email address",
    addEmailAddressOnAccount:"Add your email address to your account.",
    AddMobileNumber: "Add mobile number",
    AddMobileNumberOnAccount: "Add your mobile number to your account.",
    Google: "Google",
    SkipAndVerifyLater:"Skip & Verify Later",
    

    //InviteUser
    Whatis: "What is",
    toBeMonitoredBySomeone: "Want to be monitored by someone?",
    inviteBySendingEmail: "Invite to All Well by sending Email",
    invite: "INVITE",
    whatIsToBeMonitoredBy: "to be monitored by someone ",
    clickForMoreInfo: "For more information click",
    monitoredByUser: "to be monitored by user",
    toMonitorSomeone: 'Know wellness of a "Senior"',
    whatIsToMonitorSomeone: "to monitor someone",
    ContactAlreadySelected: "This contact is already added",
    InviteSentSuccessfully: "Invitation sent successfully.",
    PendingInviteDialogTitle: "Pending Connection Request",
    PendingInviteDialogMessage:
        "You have some pending connection requests. Please accept or reject them.",
    PendingInviteDialogButtonText: "View Requests",

    //ProfileDetails
    cancel: "CANCEL",

    //Mycare Tab
    MyCareCircleTitle: "MY CARE CIRCLE",
    InviteMycareTitle: "Invite My Care",
    ManageMyCircle: "Manage My Circle",
    InviteLovedOnesMessage: "Invite people to join your Care Circle.",
    JoinLovedOneCircleInfoText:
        "They’ll be able to receive your health and wellness updates.",
    InviteCareGiverMessage: "Invite your loved ones to join your Care Circle.",
    InviteMessage: "Invite and connect with your loved ones & caregivers.",
    JoinCareGiverCircleInfoText:
        "You’ll be able to keep up to date with their health and well being.",
    AddFromFontacts: "ADD FROM\nCONTACTS",
    AddUsingMobNo: "ADD USING\nMOBILE NUMBER",
    AddUsingMobileNo:"Add using mobile number",
    SendInvite: "SEND INVITE",
    SendInvites: "SEND INVITES",
    Add: "ADD",
    ADD:"Add",
    More: "More",
    SelectedContacts: "Selected Contacts",
    SelectedValidContactsMessage:
        "Please select contacts with country code and valid mobile numbers.",
    SelectedContactsWithMobileNoMessage:
        "Please select contacts with mobile number.",
    ContactIsAlreadyAdded: "Contact is already added",
    SelfNumberSelectedErrorMsg:
        "You have selected your own number. Please select other user's number.",
    SelfNumberAddedErrorMsg:
        "You are adding your own number. Please add other user's number.",
    SelfEmailAddedErrorMsg:
        "You are adding your own Email. Please add other user's Email.",
    AddFromContacts: "Add from Contacts",
    selectNumber: "Select Number",
    RemoveConnection: "Remove Connection",
    ConnectionRemovedSuccess: "Connection was removed successfully!",

    //sampleText's
    sampleParagraph:
        "Within this services you can know wellness of a loved one. You can become the Caregiver for the Senior. Click “Know Wellness” to know more.",

    //placeholders
    EmailPlaceholder: "Enter Email Here",
    FirstNamePlaceholder: "Your first name",
    LastNamePlaceholder: "Your last name",
    CodePlaceholder: "Enter Code",
    MobileNoPlaceholder: "Your mobile number",
    DobPlaceholder: "Select Date",
    PasswordPlaceholder: "Enter Password Here",
    ConfirmPasswordPlaceholder: "Enter Confirm Password Here",
    CountryPlaceHolder: "Country",
    MobileNumberPlaceHolder: "Mobile Number",
EmailAddressPlaceholder:"Email Address",
    //Validations
    EmailValidation: "Email field required",
    FnameValidation: "First name required",
    LnameValidation: "Last name required",
    CodeValidation: "Code required",
    MobNoValidation: "Mobile no required",
    PassValidation: "Password required",
    ConfirmPassValidation: "Confirm password required",
    InvalidEmailValidation: "Invalid email id",
    FullNameValidation: "Full name required",
    InvalidCreditCardInfo: "Invalid credit card info",

    // Tab names
    Home: "HOME",
    CareCircle: "CARE CIRCLE",
    Plans: "PLANS",
   // Message:"MESSAGE",
    Settings: "SETTINGS",
    Alerts:"ALERTS",
    View: "VIEW",

    //clientDashboard
    myData: "MY DATA",
    myLovedOnes: "My Loved Ones",
    callIcon: "call Icon",
    syncedGoogleFit: "Synced Google Fit",
    rechargeBtn: "RECHARGE",
    inviteBtn: "INVITE",
    viewPastData: "View charts",
    viewMoreParams: "View more parameters",
    inviteLovedOne: "Invite Loved One",
    whatIs: "What Is",
    whatIsMonitoredBy: "To Share Your Wellness",
    atHome: "At Home",
    hecticDay: "Had Hectic Day",
    lastActivity: "Last activity",
    firstActivity: "First activity",
    recentActivity: "Recent activity",
    sleepHrs: "Sleep Hrs",
    restHrs: "Rest Hrs",
    todaySteps: "Today steps",
    rechargeNowText1: "Your Plan is about to end soon!",
    rechargeNowText2: "Recharge now to continue availing benefits",
    MyLovedOnes: "MY LOVED ONES",
    MyCareGivers: "MY CAREGIVERS",
    MyDashboard: "MY HOME",
    MyDetails: "My Details",
    UpgradeMessage: "Please upgrade your access to view more data and information.",
    UPGRADE: "UPGRADE",
    UpgradeNow: "Upgrade Now",
    Updated: "Updated: ",
    ContactMessage: "Please contact us to make changes to your existing plan.",

    "Wake Up": "Wake Up",
    "Last Activity": "Last Activity",
    Steps: "Steps",
    Distance: "Distance",
    "More Details": "MORE DETAILS",

    ErrorNoActivityAvailable: "Information not available.",

    HowAreYouFeeling: "HOW ARE YOU FEELING TODAY?",
    ShareThis: "SHARE THIS",
    Feeling: "Feeling",
    LastLocation: "Last Location",
    sleepHours: "Sleep Hours",
    HeartRate:"Heart Rate",
    Happy: "Happy",
    Fine: "Fine",
    DownDull: "Down",
    Sad: "Sad",
    ErrorFutureDateSelected: "Future date cannot be selected",
    "BloodPressureUnitManual": "(m)",
    "BloodPressureUnitAutomatic": "(a)",
    "BloodPressureInfo": "Blood pressure data is in the format \'Systolic / Diastolic\'.  \'m\' indicates it was entered manually in All Well, whereas \'a\' indicates it was fetched using ",
    "GoogleFit": "Google Fit",
    "caloriesInfoText": "Most phones estimate and update Active Calorie data infrequently.",
    HeartRateUnit: "bpm",
    BodyTemperatureUnit: "F",
    "timeMinuteUnit": 'm',
    "timeHourUnit": 'h',
    "ACTIVE STEPS": "ACTIVE STEPS",
    "SLEEP HOURS":"SLEEP HOURS",
    "BLOOD PRESSURE": "BLOOD PRESSURE",
    Systolic: "Systolic",
    Diastolic: "Diastolic",
    Pulse:"Pulse",
    HeartRateBPM:"HEART RATE (BPM)",
    SPO2:"SPO2",
    SpO2:"SpO2",
    BodyTemperature:"BODY TEMPERATURE",
    bodyTemperature:"Body Temperature",
    RespirationRate:"RESPIRATION RATE",
    respirationRate:"Resperation Rate",
    DISTANCE: "DISTANCE",
    METERS: "(METERS)",
    "ACTIVE CALORIES": "ACTIVE CALORIES",
    KCAL: "(KCAL)",
    STATUS: "STATUS",
    "SCREEN TIME": "SCREEN TIME",
    MINUTES: " (MINUTES)",
    HOURS: " (HOURS)",
    Updating: "Updating",
    NotAvailable: "N/A",
    infoText:
        "This feature is not supported by your device. Please considering upgrading your device to activate this feature.",

    //My Care Invite
    Relationship: "Relationship",
    InviteUsingMobileNumber: "Invite using Mobile #",
    distance_meter: "m",
    distance_km: "km",

    // Manage My Circle
    LOVED_ONES: "LOVED ONES",
    CAREGIVERS: "CAREGIVERS",
    Details: "DETAILS",
    ActiveCalories: "Active Calories",
    Status: "Status",
    Pending: "Pending",
    Approved: "Approved",
    PendingInvites:"Pending Invites",
    NoDataAvailableForDateMsg:
        "No data available, try selecting a different date. ",
    NoConnections: "No connections",
    NoLovedOnes: "No loved ones connected",
    NoLovedOnesMessage:
        "Please invite and connect with your loved ones to get started.",
    InviteLovedOnes: "Invite Loved Ones",
    NoCaregivers: "No caregivers connected",
    NoCaregiversMessage:
        "Please invite and connect with your caregivers to get started.",
    InviteCaregivers: "Invite caregivers",
    ScreenTime: "Screen Time",

    Day: "DAY",
    Week: "WEEK",
    Month: "MONTH",

    FAQS: "FAQs",
    ProPlans:"Pro Plans",
    InviteLovedOnes_CAP: "INVITE LOVED ONES",
    PleaseInviteAndConnectMessage:
        "Please invite and connect with your loved ones to get started.",
    NoDataAvailable: "No Data Available",

    Invites: "Invite",
    Accept: "Accept",
    Decline: "Decline",
    HowAreYouRelatedTo: "How are you related to ",
    Save: "Save",
    Skip: "Skip",
    RelationShipErrorMessage: "Please choose relationship!",

    // Profile
    MyProfile: "My Profile",
    ProfileSettings: "Profile Settings",
    EditProfile: "Edit Profile",
    YearOfBirth: "Year of Birth",
    Location: "Location",
    Senior: "Loved One",
    CareGiver: "Caregiver",
    AboutUs: "About Us",
    FAQ: "FAQ",
    CONTACTUS: "CONTACT US",
    ABOUTUS: "ABOUT US",
    SetAlerts: "Set Alerts",

    // Edit Profile
    EmailPlaceHolder: "Email",
    User: "User",
    Permissions: "Permissions",
    GoogleFit: "Google Fit",
    LocationPermission: "Location Permission",
    LocationPermissionMessage: "Location Permission require for the App!",
    Ok: "Ok",
    ContactUsPlaceHolder: "Contact Us",
    Submit: "SUBMIT",
    Topic: "Topic",
    Message: "Message",
    EmailId: "Email ID",
    Subject: "Subject",
    Select: "Select",
    AccountName: "Account Name",
    ContactUsSucccessMessage:
        "Thank you for contacting us.\n\nWe have received your inquiry and will respond to you shortly.",
    MANAGE: "MANAGE",
    SelectGender: "Select gender",
    SelectBirthYear: "Select birth year",
    Health: "Health",
    Motion: "Activity",
    HealthDesc:
        "Enables your family/caregivers to see your health info. Check if you have provided appropriate permissions in Health app. Health > Sources > Apps > All Well",
    LocationDesc: "We will use your location data to better track you.",
    MotionDesc: "Enables your family/caregivers to see your activity data.",
    Send: "Send",
    Check: "CHECK",

    // About Us
    AboutUsSlogan: "Your loved ones are\nALL WELL",

    General: "General",
    Orders: "Orders",
    TechnicalSupport: "Technical Support",
    Payment: "Payment",
    FeatureRequest: "Feature Request",
    Partnerships: "Partnerships",
    Support: "Support",
    SomethingElse: "Something Else",

    Contact: "Contact",
    AboutUsDesc:
        "Keep up to date with their health and well being, track and monitor their activity levels and get notified when something’s wrong.",
    TermsConditions: "TERMS & CONDITIONS",
    PrivacyPolicy: "PRIVACY POLICY",
    TermsOfUse: "TERMS OF USE",
    AllWellMessage: "Your loved ones are\n ALL WELL",
    VisitWebsite: "VISIT WEBSITE",
    OtpTextInfo:"You will receive a text message with OTP code. Message and data rates may apply",

    //Checkout
    Checkout: "CHECKOUT",
    UpgradePurchaseSummary: "Upgrade/Purchase Summary",
    StartDate: "Start Date",
    AccessCount: "Connection Count",
    Access: "Access",
    Term: "Term",
    AutoRenewal: "Auto Renewal",
    TotalPrice: "Total Price",
    TransactionId: "Transaction ID",
    ExpiryPlaceHolder: "MM/YY",
    CvvPlaceHolder: "CVV",
    BillTo: "Bill To",
    PaymentMethod: "Payment Method",
    FullName: "Full Name",
    EmailAddressForReceipt: "Email Address for Receipt",
    ByTappingPayMsg: "By tapping pay, you agree to our",
    Pay: "PAY",
    On: "On",
    Annual: "Annual",
    Monthly: "Monthly",
    PaymentSuccessful: "Payment Successful.",
    PaymentFailure: "Payment Failure.",
    AddCard: "ADD CARD",

    //Subscription plan comparison
    Features: "Features",
    "Plans&DataServices": "PLANS & DATA SERVICES",
    FREE: "FREE",
    Free: "Free",
    PLUS: "PLUS",
    PREMIUM: "PREMIUM",
    PRO_PREMIUM: "PRO-PREMIUM",
    Current: "Current",
    Upgrade: "Upgrade",
    DataUpdatesEvery: "Data updates every",
    DataReportDays: "Data & Report Availability",
    PlanPricePerMon: "Price/month",
    Hours: "Hour(s)",
    Days: "Day(s)",
    Weeks: "Week(s)",
    LovedOne: "Loved One",
    FamilyCaregivers: "Family/Caregivers",
    viaMobileNumber: "VIA MOBILE NUMBER",
    fromContacts: "FROM CONTACTS",
    "InviteFamily&Caregivers": "Invite Family & Caregivers",
    "Checkout&Pay": "CHECKOUT & PAY",
    Total: "Total",
    PayAnnually: "Pay Annually",
    PayMonthly: "Pay Monthly",
    priceMo: "Price/month",
    UpgradeTo: "Upgrade To",
    "Name&CurrentPlan": "Name & Current plan",
    CONTINUE: "CONTINUE",
    contact: "CONTACT",
    NotApplicable: "Not Applicable",
    planComparisonTitle: "PLAN FEATURES & UPGRADES",
    upgradePlanTitle: "UPGRADE PLAN",
    UNSUBSCRIBE: "UNSUBSCRIBE",
    thisPlan: "this Plan",
    UnsubscribedSucessfully: "Unsubscribed successfully.",
    Confirm: "Confirm",
    NO: "NO",
    YES: "YES",
    UnsubscribeConfirmationMsg: "Are you sure you want to unsubscribe?",
    HaveSpecialCode: "Have a coupon code?",
    CouponCode: "Coupon Code",
    CouponApplied: "Coupon Applied",
    ConnectionsFor: "connections for",
    months: "months",
    FreeFor: "Free for",
    MonthAfter: "month after",
    CouponCodeWarning:
        "Please check that you have added all the connections etc. You won't be able to change these.",

    ERROR_UPGRADE_PLAN:
        "We're sorry, something went wrong. Please check your payment details and try again. Contact us if this problem persists.",
    ERROR_CALCULATE_PRICE: "Select one or more members to proceed.",
    AndroidSubscriptionInfoMsg: "{{amount}} purchase or a lesser, prorated amount for {{period}} subscription for {{connectionCount}} connection(s) will be applied to your payment method at the at the confirmation of purchase. Subscription automatically renews unless it is canceled before the end of the current period. For more information, please see our Terms & Conditions. ",
    TermsCondition: "Terms & Conditions",
    Privacypolicy: "Privacy Policy",
    CONTACT: "CONTACT",
    SelectTerm: "SELECT TERM",

    //Plans
    MyPlanStatusHistory: "MY PLAN STATUS & HISTORY",
    Name: "Name",
    PaidBy: "Paid By",
    UPGRADEPLAN: "UPGRADE PLAN",
    TransactionHistory: "Transaction History",
    EmailSummary: "Email Summary",
    EMAILSUMMARY: "EMAIL SUMMARY",
    people: "people",
    NoTransactionHistory: "No Transaction History",
    HaveQuestions: "Have questions?",
    Off: "Off",
    Failed: "Failed",
    UpgradeFor: "Upgrade for",
    Users: "Connection(s)",
    BillingMessage: "Billed on 1st of every month.",
    ProratedChargeMessage: "Prorated amount charged today.",
    YourLovedOnesAre: "Your loved ones are",
    ALLWELL: "ALL WELL",
    Version: "Version",
    ComingSoon: "Coming soon*:",
    IAPSubscriptionInfo:
        "A %{amount} purchase for %{period} subscription for %{connectionCount} connection(s) will be applied to your Apple ID account at the confirmation of purchase. Subscription automatically renews unless it is canceled at least 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period. You can manage and cancel your subscriptions by going to your account settings on the App Store after purchase. For more information, see our",
    IAPDiscountSubscriptionInfo:
        "A discounted %{discountAmount} purchase for monthly subscription for %{connectionCount} connection(s) will be applied to your Apple ID account for the duration of %{discountTerm} months. After %{discountTerm} months, %{amount} purchase for %{period} subscription for %{connectionCount} connection(s) will be applied to your Apple ID account at the confirmation of purchase. Subscription automatically renews unless it is canceled at least 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period. You can manage and cancel your subscriptions by going to your account settings on the App Store after purchase. For more information, see our",

    /* Chat Features */
    message: "MESSAGE",
    AllCaregivers: "ALL CAREGIVERS",
    ChatPlaceholder: "Type your message here…",
    LoadEarlierMessages: "LOAD EARLIER MESSAGES",

    Manage: "Manage",
    Reports: "REPORTS",
    "SELECT REPORTS": "SELECT REPORT",
    SaveAndSend: "SAVE AND SEND",
    AddFromComtacts: "ADD FROM CONTACTS",
    ScheduleReports: "Schedule Reports",
    NoReports: "No reports have been scheduled",
    UpgradeToSchedule: "Upgrade to schedule and send reports",
    QuickSend: "Quick Report",
    DailyCharts: "Day Report & Charts",
    WeeklyCharts: "Week Report & Charts",
    MonthlyCharts: "Month Report & Charts",
    SetASchedule: "SET A SCHEDULE",
    DeleteRecipientPopupHeader: "Delete Recipient",
    DeleteRecipentReportMessage: "Are you sure you want to delete recipient?",
    DeleteSuccess: "Recipient deleted successfully",
    SendReport: "Send Report",
    DownloadReport: "Download Report",
    RecipientName: "Recipient Name",
    RecipientNameError: "Enter Recipient name",
    RecipientEmail: "Recipient Email Address",
    RecipientEmailError: "Enter recipient email address",
    ReportSentSuccessfully: "Email report sent successfully.",
    WelcomeToastMessage:
        "Welcome To All Well. Please note that some data will be inaccurate for the first day as we are just getting started!",

    //Alerts screen
    DefaultAlertsUsedMessage: "You have used 0/1 Alerts",
    WakeUpTime: "Wake Up Time",
    Active: "ACTIVE",
    Inactive: "INACTIVE",
    WakeupAlertMessage:
        "Alert me if my Loved One does not wake up by a certain time.",
    Time: "Time",
    NotifyMeAt: "Notify me at ",
    CaregiverAlertMessage:
        "Caregiver will get notified about alert as per his time zone",
    NotifyMeBy: "Notify Me By",
    TurnOn: "TURN ON",
    TurnOff: "TURN OFF",
    StepCount: "Step Count",
    StepsCount: "Steps Count",
    StepCountAlertMessage:
        "Alert me if my Loved One does not meet her daily step count goal.",
    DayGoal: "Daily Goal",
    EndTime: "End Time",
    PhoneNotification: "Phone Notification",
    TextMessage: "Text Message",
    DailyToastMessageText:
        "Daily step count data is estimated and reported by the phone and could be a little off.",
    Cancel: "Cancel",
    AllowAccessTxt:
        "You must enable and allow All Well to access your phone data to:",
    ViewDataCharts: "View data and charts",
    SharewithFamilyTxt: "Share it with your family & caregivers",
    FeatureLineHere: "Update how you’re feeling",
    ActivateBtnText: "ACTIVATE",
    ActivateAccToast: "View your data & Invite caregivers to share updates",
    ActivateAccToastCaregiver: "Monitor & Connect with your loved ones",
    UpdatePhoneNumberMessage:
        "Please update the phone number in order to use all features.",
    Update: "UPDATE",
    PhoneNumberRequired: "Phone Number Required",
    Phone_Number:"Phone Number",
    PhoneNumberRequiredMessage:
        "Adding your phone number ensures you can receive and send invitations and can use all the features.",

    //Switch account
    Role: "Role",
    Caregiver: "Caregiver",
    CaregiverInfo: "They can view your data",
    LovedOneInfo: "You can view their data",
    CaregiverRoleInfoToast:
        "They will be able to access & monitor your health & well-being.",
    LovedOneRoleInfoToast:
        "You will be able to access & monitor their health & well-being.",
    SelectRole: "Select Role",
    RoleInformationToast:
        "Please select the role for your invitee. You may invite them again with a different role. A loved one will allow you to access their well-being data. A caregiver will have access to your well-being data.",
    AddNumber: "Add Phone Number",
    signUpOnApp: "SIGN UP ON APP",
    OTPResentSuccessFully: "OTP resent successfully!",
    OTPInfoText:
        "We sent you a one-time password (OTP) on your phone.Enter it below.",
    OTPInfoEmailText:"We sent you a one-time password (OTP) on your Email Address.Enter it below.",
    OTPCannotBeBlank: "OTP cannot be blank",
    InvalidOTPEntered: "Invalid OTP entered",
    CloseAndLogin: "Close & Login",
    VERIFY: "VERIFY",
    LOGIN: "LOGIN",
    WakeUp: "Wake Up",
    LastActivity: "Last Activity",
    MoreDetails: "More Details",
    LessDetails: "Less Details",
    BloodPressure: "Blood Pressure",


    // Error: "Error",
    ErrorOccurred: ' Error Occurred!',
    Session: "Session",
    Expired: " Expired",
    Verifi: "Verifi",
    cation: "cation",
    toYourExistingAccount: "to your existing account",
    LoginText: "Login",
    TERMS: "TERMS",
    Country: "Country",
    AllWellAppSite: "AllWellApp.com",
    Visit: "Visit",
    DontReceivedOtpText:
        "I didn't recieve OTP to Didn't receive it? Please wait for two minutes and try again!",

    //invitation strings
    InvitationInfoPart1: "Congratulations, you are now connected to ",
    InvitationInfoPart2: ". Access their daily activity data for free using the All Well mobile app.",
    InstallApp: "INSTALL APP",
    LearnMore: "LEARN MORE",
    InstallAppInfo: "Install our free app on your mobile device to use all our features including data sync, messages and more",
    emptySetAlert: "Please enable your health stats or connect with a loved one to set data alerts.",
    InviteOrConnect: "Invite or connect with Loved ones",
    InvitationInfo1: "Please install our free mobile app to access ",
    InvitationInfo2: " activity and health information.",
    ActionNotAvailable: "Action Not Available",
    ActionNotAvailableInfo:"This action is not available in demo. Please add and connect with a loved one or activate your data to enable this feature. ",
    "CaregiverBtnText": "REQUEST ACCESS",
    "GiveAccess": "GIVE ACCESS",
    Manage_Access: "Manage Access",
    Manage_AccessInfo: "Give access or request access from others",
    PendingAccessRequests:"Pending Access Requests",

    //reports
    INVALID_REPORT_OF_USER:"INVALID_REPORT_OF_USER",
    INVALID_RECIPIENTS:"INVALID_RECIPIENTS",
    INVALID_RECIPIENT_ID:"INVALID_RECIPIENT_ID",
    INVALID_RECIPIENT_NAME:"INVALID_RECIPIENT_NAME",
    INVALID_RECIPIENT_EMAIL:"INVALID_RECIPIENT_EMAIL",
    INVALID_REPORTS:"INVALID_REPORTS",
    INVALID_ID:"INVALID_ID",
    INVALID_NAME:"INVALID_NAME",
    INVALID_FREQUENCY:"INVALID_FREQUENCY",
    INVALID_DAY:"INVALID_DAY",
    INVALID_TIME:"INVALID_TIME",
    INVALID_DATE:"INVALID_DATE",
    INVALID_SCHEDULE_TYPE:"INVALID_SCHEDULE_TYPE",
    FAILED_TO_CREATE_REPORT:"FAILED_TO_CREATE_REPORT"

};
